import { Http } from "../../../http";
import { WLP_SUBSCRIBE_NOLOGON } from "../../../config";
import { SubscribeInterface } from "../../../http/interface.api";
import { ServerResponse } from "../../../http/api";

interface FormParams {
  [k: string]: string | Blob | undefined;
}

interface OrderResponse extends ServerResponse {
  ErrCode?: number;
}

const WlpApiPaths = {
  placeOrder: WLP_SUBSCRIBE_NOLOGON
    ? "api/nologon/place_order"
    : "api/place_order",
  subscribe: WLP_SUBSCRIBE_NOLOGON
    ? "api/nologon/subscribe"
    : "api/subscribe",
} as const;

function buildFormData(params: FormParams = {}, removeEmpty = true): FormData {
  const formData = new FormData();

  for (const key of Object.keys(params)) {
    if (!params[key] && removeEmpty) {
      continue;
    }

    let value = params[key];
    if (!(value instanceof Blob)) {
      value = "" + value;
    }

    formData.append(key, value);
  }

  return formData;
}

async function subscribe(data: SubscribeInterface, recaptcha: string) {
  const formData = buildFormData({
    email: data.email,
    name: data.name,
    "g-recaptcha-response": recaptcha,
  });

  const response = await Http.request<ServerResponse>({
    method: "POST",
    url: WlpApiPaths.subscribe,
    data: formData,
  });

  return response.data;
}

async function order(data: Record<string, string | Blob | undefined>, recaptcha?: string) {
  const formData = buildFormData({
    ...data,
    "g-recaptcha-response": recaptcha,
  });

  const response = await Http.request<OrderResponse>({
    method: "POST",
    url: WlpApiPaths.placeOrder,
    data: formData,
    headers: { "Content-Type": "multipart/form-data" },
  });

  return response.data;
}

export const wlpFormsApi = {
  subscribe,
  order,
};
